import React, { useState } from "react";
import Modal_started from "../Home/Modal_started";
import useDocumentTitle from "../../useDocumentTitle";
import { Link } from "react-router-dom";

const LogoMarquee = ({
    speed = 48,     // mayor = más sutil/lento
    gapRem = 3,     // separación entre logos (rem)
  }) => {

    const brandAdjust = {
      "Sushiexpress1.webp": "scale-90",
      "Elcosto.webp": "scale-90",
      "Grupotova.webp": "scale-90",
    };
  
    const logos = [
      // === 9 nuevos primero ===
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Yogen_Fruz_Logo.svg_rbdk1o.png", alt: "Yogen Fruz" },
      { src: "https://img.invupos.com/clauweb/Empresas/Olive-garden.png", alt: "Olive Garden" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Krispy_Kreme_logo.svg_sshr2p.png", alt: "Krispy Kreme" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Subway.logo.8.5_e0sw4o%20%283%29.svg", alt: "Subway" },
      { src: "https://img.invupos.com/webinvu/Delivery/SOCIALTEL-LOGO-02.png", alt: "Selina" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/cropped-Website-Ajisen-37_vdskkr.webp", alt: "Ajisem Ramen" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/IHOP_logo.svg_nwncuz.png", alt: "Ihop" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Cinnabon_logo.svg_unlk2s.png", alt: "Cinnabon" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Little-Caesars-Logo_elzm7x.png", alt: "Little Caesars" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/Logo-maito-negro_vl6w8p.png", alt: "Maito" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/cantina-del-tigre_nb9rjo.png", alt: "Cantina del tigre" },
      { src: "https://img.invupos.com/webinvu/LogoMarquee/UNIDO_LOGO_01_1_riim8k.png", alt: "Unido" },
    ];
  
    // Duplicamos dentro de UNA sola pista para loop perfecto sin “salto”
    const track = [...logos, ...logos];
  
    return (
      <div
        className="relative w-full overflow-hidden py-10 group"
        // máscara sutil para entradas/salidas suaves
        style={{
          WebkitMaskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          maskImage:
            "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
        }}
      >
        <style>{`
          @keyframes marqueeX {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .marquee-track {
            display: flex;
            align-items: center;
            width: max-content;
            animation: marqueeX var(--marquee-duration, 48s) linear infinite;
            will-change: transform;
          }
          .marquee-track > * + * { margin-left: ${gapRem}rem; } /* separación entre “cajas” */
          .paused { animation-play-state: paused; }
  
          /* Respeta reduce motion */
          @media (prefers-reduced-motion: reduce) {
            .marquee-track { animation: none !important; transform: none !important; }
          }
  
          /* Ajuste leve por viewport para elegancia */
          @media (min-width: 1024px) {
            .marquee-root { --marquee-duration: ${speed + 6}s; }
          }
          @media (max-width: 480px) {
            .marquee-root { --marquee-duration: ${Math.max(30, speed - 6)}s; }
          }
        `}</style>
  
        <div className="marquee-root">
          <div className={`marquee-track group-hover:paused`}>
            {track.map((logo, i) => {
              // detectar nombre de archivo para ajuste fino opcional
              const filename = logo.src.split("/").pop() || "";
              const tweak = Object.keys(brandAdjust).find(key =>
                filename.includes(key)
              );
              const scaleClass = tweak ? brandAdjust[tweak] : "";
  
              return (
                <div
                  key={i}
                  className="flex-shrink-0 flex items-center justify-center 
                             h-[68px] sm:h-[76px] lg:h-[86px]
                             w-[clamp(140px,12vw,240px)]" // caja uniforme
                >
                  <img
                    src={logo.src}
                    alt={logo.alt || ""}
                    loading="lazy"
                    className={`max-h-full max-w-full object-contain ${scaleClass}`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

export default function Delivery({ images = {} }) {
  const {
    hero = "https://img.invupos.com/webinvu/Delivery/INVU_POS_El_Salvador-9_2_nquqgv.png",
    sellEverywhere = "https://img.invupos.com/webinvu/Delivery/INVU_POS_El_Salvador-10_1_1_yivwp1.png",
    integrations = "https://img.invupos.com/webinvu/Delivery/INVU_POS_El_Salvador-9_3_t18s5r.png",
    devicesMock = "https://img.invupos.com/webinvu/Delivery/Whatsapp_Catalogo-3_1_uehgod.png",
    clauLogo = "https://img.invupos.com/webinvu/Delivery/logoclau_1_hzgjgq.png",
  } = images;

  const [isOpen, setIsOpen] = useState(false);
  useDocumentTitle("DELIVERY | INVU POS");

  return (
    <>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />}
    <main className="text-gray-900">
      {/* HERO */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight">
            Un POS que agiliza tu <span className="text-blue-600">delivery</span> en un solo lugar
          </h1>
          <p className="mt-6 text-lg text-gray-700 max-w-2xl">
            Olvídate de manejar múltiples pantallas o perder tiempo organizando pedidos: nuestra integración con las principales plataformas de delivery te permite recibir, gestionar y despachar órdenes directamente desde tu POS.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
          <button
              onClick={() => {
              setIsOpen(true);
            }} className="px-6 py-3 rounded-full bg-blue-600 text-white font-semibold shadow" href="#demo">Prueba el demo</button>
            <button
              onClick={() => {
              setIsOpen(true);
            }} className="px-6 py-3 rounded-full bg-gray-100 text-gray-900 font-semibold border" href="#empieza">Empieza Hoy</button>
          </div>
        </div>
        <div className="w-full max-w-xl mx-auto">
          {hero ? (
            <img src={hero} alt="Hero" className="w-full rounded-2xl" />
          ) : (
            <div className="w-full h-80 bg-gray-200 rounded-2xl" />
          )}
        </div>
      </section>

      <section>
        <div className="px-4 py-12 mt-4 mx-auto max-w-screen-xl">
          <LogoMarquee speed={42} gapRem={2} />
        </div>
      </section>

      {/* EL PODER DE VENDER EN TODOS LADOS */}
      <section className="bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
          <h2 className="text-4xl sm:text-5xl font-extrabold">El poder de vender en todos lados</h2>
          <div className="mt-10 grid lg:grid-cols-2 gap-10 items-start">
            <div>
              {sellEverywhere ? (
                <img src={sellEverywhere} alt="Repartidora sonriendo" className="w-full h-[22rem] sm:h-[26rem] lg:h-[28rem] object-cover rounded-[28px]" />
              ) : (
                <div className="w-full h-80 bg-gray-200 rounded-[28px]" />
              )}
            </div>
            <ul className="space-y-8 text-lg">
              <li>
                <p className="font-extrabold">Pedidos centralizados:</p>
                <p className="text-gray-700">todos los pedidos de delivery en un solo sistema, sin errores ni duplicaciones.</p>
              </li>
              <li>
                <p className="font-extrabold">Procesos más rápidos:</p>
                <p className="text-gray-700">sincronización automática con la cocina y actualización de inventario en tiempo real.</p>
              </li>
              <li>
                <p className="font-extrabold">Mayor visibilidad:</p>
                <p className="text-gray-700">tus menús y promociones llegan a más clientes a través de todas las plataformas conectadas.</p>
              </li>
              <li>
                <p className="font-extrabold">Decisiones inteligentes:</p>
                <p className="text-gray-700">reportes detallados de ventas y comportamiento de clientes para impulsar tu negocio.</p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SISTEMA INTEGRADO */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <h2 className="text-4xl sm:text-5xl font-extrabold">
          Sistema integrado para mayor <span className="text-blue-600">eficiencia</span>
        </h2>
        <div className="mt-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="max-w-2xl text-gray-700 text-lg">
            Ya sea que recibas pedidos desde Uber Eats, Rappi, PedidosYa o tu propio ecommerce, tu inventario y tus ventas se actualizan automáticamente, dándote control total sobre tu negocio.
            <div className="mt-6">
            <Link 
            to={"/mas-herramientas/integraciones"} className="px-6 py-3 rounded-full bg-blue-600 text-white font-semibold inline-block">Descubre más integraciones</Link>
            </div>
          </div>
          <div className="max-w-2xl mx-auto">
            {integrations ? (
              <img src={integrations} alt="Integraciones" className="w-full rounded-2xl" />
            ) : (
              <div className="w-full h-72 bg-gray-100 rounded-2xl" />
            )}
          </div>
        </div>

        {/* Métricas */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">Incorporación simplificada</div>
            <div className="mt-3 text-5xl font-extrabold">100<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">Gestiona todos tus pedidos y plataformas desde un solo sistema intuitivo.</p>
          </div>
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">Reducción de errores</div>
            <div className="mt-3 text-5xl font-extrabold">99<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">Olvídate de pedidos duplicados o mal ingresados, todo fluye automáticamente.</p>
          </div>
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">Incrementa tus pedidos</div>
            <div className="mt-3 text-5xl font-extrabold">45<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">Llega a más clientes, procesa pedidos rápido y aumenta tus ingresos.</p>
          </div>
        </div>
      </section>

      {/* DELIVERY AL INSTANTE */}
      <section className="bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            {devicesMock ? (
              <img src={devicesMock} alt="Dispositivos con tienda" className="w-full rounded-2xl" />
            ) : (
              <div className="w-full h-72 bg-gray-200 rounded-2xl" />
            )}
          </div>
          <div>
            <h3 className="text-4xl sm:text-5xl font-extrabold leading-tight">
              Delivery al instante con <span className="text-blue-600">Invu POS</span> desde cualquier dispositivo
            </h3>
            <p className="mt-6 text-lg text-gray-700">
              Con la experiencia de <span className="font-semibold">Clau.IO</span> en e-commerce para restaurantes y la potencia de <span className="font-semibold">Invu POS</span>, tu negocio funciona de manera más inteligente. Gestiona pedidos, controla inventarios, genera reportes y mantén toda la operación al día desde un solo lugar.
            </p>
            <p className="mt-4 text-lg text-gray-700">
              La combinación perfecta para restaurantes que buscan eficiencia, control y crecimiento constante.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              {clauLogo ? <img src={clauLogo} alt="CLAU.IO" className="h-8" /> : null}
              <a href="https://clau.io/" target="_blank" className="px-6 py-3 rounded-full bg-blue-600 text-white font-semibold">Descubre sobre CLAU.IO</a>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}
